import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  imports: [DatePickerModule, FloatLabelModule, FormsModule],
  templateUrl: './datepicker.component.html',
  styleUrl: './datepicker.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true,
    },
  ],
})
export class DatepickerComponent {
  @Output() onSelectChange = new EventEmitter<any>();
  @Input() inputlabel: string = '';

  selectedScheduledDate:any = null;

  private onChange: any = null;
  private onTouched: any = null;

  
  writeValue(value: any): void {
    this.selectedScheduledDate = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {}

   onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
    if (this.onChange) {
      this.onChange(event);
    }
    this.onSelectChange.emit(event);
  }
}
